import React, { useEffect, useState, useRef } from "react";
import { Redirect } from "react-router-dom";
import Columns from "./Columns";
import {
  getDashboardPasajes,
  resourcesUnits,
} from "../../helpers/backend_helper";
import { Container, Spinner } from "reactstrap";
import { getStorageCompany, getStorageUser } from "../../helpers/api_helper";
import ButtonHelper from "../../helpers/ButtonHelper";
import Select from "react-select";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import InfoModal from "./InfoModal";
import { PROFILES } from "../../components/VerticalLayout/SidebarContent";

const RealTimeTicketPrices = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${timeElapsed.getMonth() + 1 < 10 ? "0" : ""
    }${timeElapsed.getMonth() + 1}-${timeElapsed.getDate()}`;

  const authUser = getStorageUser();

  // /dashboard-realtime-ticket-prices esta en la whitelist de App.js, asi que el operador
  // puede llegar tecleando la URL; este monitor es de toda la ruta y no le corresponde.
  // El guard va antes de cualquier hook para no romper el orden de hooks.
  if (authUser.profile_id === PROFILES.Operador) {
    return <Redirect to="/dashboard" />;
  }

  const company = getStorageCompany();
  const [pending, setPending] = useState(false);
  const [precioPasaje, setPrecioPasaje] = useState(false);
  const [modal, setModal] = useState({ info: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({ page: 1, perPage: 500, search: '', orderBy: 'id', order: 'asc', companySession: company.id });

  const mockedData = [
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
    {
      unit: "448",
      dineroTotal: "$520",
      boletosTotales: "50",
      conteoTotalSubidas: "50",
      conteoTotalBajadas: "33",
    },
  ];

  useEffect(() => {
    const getUnits = async () => {
      let params = { params: filters }
      setPending(true)
      const response = await getDashboardPasajes(params);
      setItems(response.data)
      setPrecioPasaje(response.pasaje)
      //setDataPag(response.meta)
      setPending(false)
    }
    getUnits();
  }, [filters])

  useEffect(() => {
    const interval = setInterval(async () => {
      let params = { params: filters }
      setPending(true)
      const response = await getDashboardPasajes(params);
      setItems(response.data)
      setPrecioPasaje(response.pasaje)
      //setDataPag(response.meta)
      setPending(false)
    }, 1000 * 60 * 1)
    return () => clearInterval(interval);
  }, [])


  const information = (row) => {
    setModal({ info: true });
  };

  const columns = Columns({ information, precioPasaje });
  document.title = "Monitor pasaje del día";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Monitor de Pasaje del día"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
              filterInp={false}
            >
              {pending ? <Spinner color="primary" /> : null}
              <ButtonHelper
                addButon={false}
                reportButons={false}
                actionReportButon={() => { }}
                pdfButton={false}
              />
            </DataTableHelper>
          </div>
        </Container>
      </div>
      <InfoModal modal={modal} setModal={setModal} />
    </React.Fragment>
  );
};

export default RealTimeTicketPrices;
